import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

const alternativeBackgroundRoutes = [
    APP_ROUTES.customerShifts,
    APP_ROUTES.candidateOffers,
    `${ APP_ROUTES.candidateOffers }/*`
];

export default function useRouteBasedStyleProps() {
    const location = useLocation();

    const isAlternativeBackground = useMemo(() => {
        const matches = matchRoutes(alternativeBackgroundRoutes.map((route) => ({
            path: route
        })), location);

        return Boolean(matches?.length);
    }, [ location ]);

    return {
        isAlternativeBackground
    };
}
